/* 引用元
1. https://react-icons.github.io/react-icons
*/

import { BsThreeDots } from 'react-icons/bs'
import { FaLongArrowAltDown, FaLongArrowAltUp } from 'react-icons/fa'
import { IconBaseProps } from 'react-icons/lib'

interface IconType extends IconBaseProps {
  BsThreeDots: typeof BsThreeDots
  FaLongArrowAltDown: typeof FaLongArrowAltDown
  FaLongArrowAltUp: typeof FaLongArrowAltUp
}

export const Icon: IconType = {
  BsThreeDots,
  FaLongArrowAltDown,
  FaLongArrowAltUp,
}
